// src/pages/job/UpdateJob.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOneJob, updateJob } from "../../slice/jobSlice";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const UpdateJob = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, loading } = useSelector((state) => state.job);

  const [formData, setFormData] = useState({
    jobTitle: "",
    experience: "",
    description: "",
  });

  // ✅ Fetch job on mount
  useEffect(() => {
    dispatch(getOneJob(id));
  }, [dispatch, id]);

  // ✅ Populate form data once job is fetched
  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setFormData({
        jobTitle: data.jobTitle || "",
        experience: data.experience || "",
        description: data.description || "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = ["jobTitle", "experience", "description"];
    const hasEmpty = requiredFields.some((key) => !formData[key]?.trim());

    if (hasEmpty) {
      toast.error("Please fill all required fields.");
      return;
    }

    try {
      await dispatch(updateJob({ id, data: formData })).unwrap();
      toast.success("Job updated successfully!");
      navigate("/joblist");
    } catch (error) {
      console.error("Failed to update job:", error);
      toast.error("Failed to update job");
    }
  };

  return (
    <div className="container-fluid px-lg-5">
      <div className="mainheadig">
        <h4 className="text-white font-weight-bold">Update Job</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row p-3">
          {[
            { label: "Job Title", name: "jobTitle" },
            { label: "Experience", name: "experience" },
          ].map(({ label, name }) => (
            <div className="col-sm-6 mt-2" key={name}>
              <label htmlFor={name}>{label}</label>
              <input
                type="text"
                name={name}
                value={formData[name]}
                className="form-control"
                onChange={handleChange}
              />
            </div>
          ))}

          <div className="col-sm-12 mt-2">
            <label htmlFor="description">Description</label>
            <textarea
              rows={4}
              name="description"
              value={formData.description}
              className="form-control"
              onChange={handleChange}
            ></textarea>
          </div>
        </div>
        <div className="my-3 text-right">
          <button className="btn addbtn" disabled={loading}>
            Update Job
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateJob;
